import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Card, InputGroup, FormControl } from 'react-bootstrap';
import { toast } from 'react-toastify'; // Importa toast para mostrar notificaciones
import { createUser } from 'services/users'; // Asegúrate de tener esta función en tu servicio
import { getAll } from 'services/roles'; // Importa la función para obtener los roles

const AddUser = () => {
  const navigate = useNavigate(); // Para redirigir después de guardar
  const [roles, setRoles] = useState([]); // Estado para almacenar los roles
  const [formData, setFormData] = useState({
    user_name: '',
    email: '',
    role_id: '', // ID del rol
    password: '3nCuE$Tas2025-019764' // Contraseña estática base
  }); // Estado para manejar el formulario

  const [errors, setErrors] = useState({}); // Estado para manejar errores de validación

  useEffect(() => {
    // Llama a la API para obtener los roles
    getAll()
      .then(response => {
        setRoles(response); // Almacena los roles en el estado
      })
      .catch(error => {
        console.error('Error al obtener los roles:', error);
      });
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    setErrors({
      ...errors,
      [name]: '' // Limpia el error al cambiar el valor
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.user_name.trim())
      newErrors.user_name = 'El nombre es requerido.';
    if (!formData.email.trim())
      newErrors.email = 'El correo electrónico es requerido.';
    if (!formData.role_id) newErrors.role_id = 'El rol es requerido.';
    return newErrors;
  };

  const handleSubmit = e => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Por favor, completa todos los campos requeridos.', {
        theme: 'colored'
      });
      return;
    }

    // Llama a la API para crear un nuevo usuario
    createUser(formData)
      .then(() => {
        toast.success(`Usuario ${formData.user_name} creado exitosamente`, {
          theme: 'colored'
        }); // Muestra un mensaje de éxito
        navigate('/users'); // Redirige a la lista de usuarios
      })
      .catch(error => {
        console.error('Error al crear el usuario:', error);
        toast.error('Ocurrió un error al crear el usuario', {
          theme: 'colored'
        }); // Muestra un mensaje de error
      });
  };

  return (
    <Card>
      <Card.Header>
        <h5>Agregar Usuario</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              name="user_name"
              value={formData.user_name}
              onChange={handleChange}
              placeholder="Ingresa el nombre del usuario"
              isInvalid={!!errors.user_name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.user_name}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Correo Electrónico</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Ingresa el correo electrónico"
              isInvalid={!!errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Rol</Form.Label>
            <Form.Select
              name="role_id"
              value={formData.role_id}
              onChange={handleChange}
              isInvalid={!!errors.role_id}
            >
              <option value="">Selecciona un rol</option>
              {roles.map(role => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.role_id}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Contraseña</Form.Label>
            <InputGroup>
              <FormControl
                type="text"
                name="password"
                value={formData.password}
                readOnly // Solo lectura
              />
              <Button
                variant="outline-secondary"
                onClick={() => {
                  navigator.clipboard.writeText(formData.password);
                  toast.info('Contraseña copiada al portapapeles', {
                    theme: 'colored'
                  });
                }}
              >
                Copiar
              </Button>
            </InputGroup>
            <Form.Text className="text-muted">
              Esta contraseña será asignada al usuario y puede ser copiada.
            </Form.Text>
          </Form.Group>
          <Button variant="primary" type="submit">
            Crear Usuario
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddUser;
